module.exports = "https://cdn.hellotech.com/client-assets/universal_remotes_tablet_683d15785c9ef59e8cbbfb74ff047fa4.webp";